import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AccessibleClickDirective } from '../directives/accessible-click.directive';

@Component({
  selector: 'lib-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, AccessibleClickDirective],
})
export class TagComponent {
  readonly title = input.required<string>();
  readonly closeEvent = output<void>();
  ariaLabel = computed(() => `Clear selected ${this.title()} filter option`);
}
